enum FileType {
  Image = 1,
  Video = 2,
  Audio = 3,
  Document = 4,
  Icon = 5,
}

export default FileType;
